var exports = {
  "tb": "UserProfileModal.module__noteTextarea___M1JWVG",
  "CR": "UserProfileModal.module__modalRoot___M1JWVG",
  "eF": "UserProfileModal.module__userInfo___M1JWVG",
  "hR": "UserProfileModal.module__userInfoHeader___M1JWVG",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___M1JWVG",
  "Rn": "UserProfileModal.module__userInfoContent___M1JWVG",
  "yn": "UserProfileModal.module__profileDataWarning___M1JWVG",
  "S7": "UserProfileModal.module__nameRow___M1JWVG",
  "nT": "UserProfileModal.module__userName___M1JWVG",
  "a1": "UserProfileModal.module__userTag___M1JWVG",
  "Fj": "UserProfileModal.module__usernameRow___M1JWVG",
  "hI": "UserProfileModal.module__pronouns___M1JWVG",
  "sM": "UserProfileModal.module__srOnly___M1JWVG",
  "Li": "UserProfileModal.module__customStatusText___M1JWVG",
  "Ef": "UserProfileModal.module__customStatusRow___M1JWVG",
  "_z": "UserProfileModal.module__tagBadgeRow___M1JWVG",
  "U3": "UserProfileModal.module__badgesWrapper___M1JWVG",
  "ZV": "UserProfileModal.module__userNoteEditor___M1JWVG",
  "xu": "UserProfileModal.module__noteLabel___M1JWVG",
  "_j": "UserProfileModal.module__noteTextareaBase___M1JWVG",
  "jd": "UserProfileModal.module__noteTextareaEditing___M1JWVG",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___M1JWVG",
  "bs": "UserProfileModal.module__profileContent___M1JWVG",
  "EM": "UserProfileModal.module__profileContentHeader___M1JWVG",
  "cI": "UserProfileModal.module__bannerContainer___M1JWVG",
  "HG": "UserProfileModal.module__bannerMask___M1JWVG",
  "_e": "UserProfileModal.module__bannerImage___M1JWVG",
  "N1": "UserProfileModal.module__headerContainer___M1JWVG",
  "H": "UserProfileModal.module__avatarContainer___M1JWVG",
  "fc": "UserProfileModal.module__actionButtonsContainer___M1JWVG",
  "hQ": "UserProfileModal.module__contentContainer___M1JWVG",
  "sq": "UserProfileModal.module__profileContentWrapper___M1JWVG",
  "zL": "UserProfileModal.module__scrollerFullHeight___M1JWVG",
  "jT": "UserProfileModal.module__modalContainer___M1JWVG",
  "uu": "UserProfileModal.module__actionButtons___M1JWVG",
  "iA": "UserProfileModal.module__buttonIcon___M1JWVG",
  "ro": "UserProfileModal.module__menuIcon___M1JWVG",
  "WB": "UserProfileModal.module__avatarFocusRing___M1JWVG",
  "VS": "UserProfileModal.module__tabsWrapper___M1JWVG",
  "OT": "UserProfileModal.module__mutualFriendsList___M1JWVG",
  "Z8": "UserProfileModal.module__mutualSectionDivider___M1JWVG",
  "KF": "UserProfileModal.module__mutualFriendItem___M1JWVG",
  "vu": "UserProfileModal.module__active___M1JWVG",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___M1JWVG",
  "D9": "UserProfileModal.module__mutualFriendInfo___M1JWVG",
  "eV": "UserProfileModal.module__mutualFriendName___M1JWVG",
  "zD": "UserProfileModal.module__mutualFriendUsername___M1JWVG",
  "p$": "UserProfileModal.module__emptyState___M1JWVG",
  "Ny": "UserProfileModal.module__mutualGuildIcon___M1JWVG",
  "me": "UserProfileModal.module__separator___M1JWVG",
  "AI": "UserProfileModal.module__emptyStateIcon___M1JWVG",
};

module.exports = exports;
